import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';

const OSANO_SRC =
	'https://cmp.osano.com/wapV4usL16/d4edf89f-c0c4-4d4f-8815-5a61e3b15c0c/osano.js';

export default function OsanoScript() {
	const [isInteractive, setIsInteractive] = useState(false);

	useEffect(() => {
		setIsInteractive(true);
	}, []);

	if (!isInteractive) {
		return null;
	}

	return (
		<Helmet>
			<script src={OSANO_SRC} />
		</Helmet>
	);
}
